// rootReducer.js
import { combineReducers } from 'redux';
import LayoutReducer from './layouts/reducer';
import OfferReducer from './offer/reducer';
import UomReducer from './uom/reducer';
import AddOfferReducer from './offer/addoffer/reducer';
import CreateCustomerReducer from './customer/create/reducer';
import UpdateCustomerReducer from './customer/update/reducer';
import FetchCustomerReducer from './customer/fetchcustomer/reducer';
import AddUomReducer from './uom/adduom/reducer';
import UsageEventTypeReducer from './usageEventType/reducer';
import AddUsageEventTypeReducer from './usageEventType/addUsageEventType/reducer';
import CustomerListReducer from './customer/customerlist/reducer';
import SimulateReducer from './customer/simulate/reducer';
import RateUsageReducer from './customer/rateusage/reducer';
import CancelSubscriptionReducer from './customer/cancelsubscription/reducer';
import ServiceReducer from '../slices/services/reducer';
import ResourceReducer from '../slices/resources/reducer';
import StationReducer from '../slices/stations/reducer';
import ReservationReducer from '../slices/reservations/reducer';
import CreateServiceReducer from '../slices/services/addservice/reducer';
import CreateResourceReducer from '../slices/resources/addresources/reducer';
import ConfigReducer from '../slices/services/addservice/eventconfiguration/reducer';
import permissionsReducer from '../permissionsSlice';
import ProvisionalReducer from "../slices/services/addservice/provisionalattribute/reducer"
import EditStationReducer from "../slices/stations/editstation/reducer"
import PostReservationReducer from "../slices/reservations/postreservation/reducer"
import UpdateReservationReducer from "../slices/reservations/updatereservation/reducer"
import GetReservationReducer from "../slices/reservations/getreservation/reducer"
import DeleteResourceReducer from "../slices/resources/deleteresource/reducer"
import CitiesReducer from "../slices/customer/cities/reducer"
import StatesReducer from "../slices/customer/states/reducer"
import CountriesReducer from "../slices/customer/countries/reducer"
import DefaultLoginReducer from "../slices/login/reducer"
import SignInReducer from "../slices/SignIn/reducer"
import welcomeToastReducer from "../slices/welcomeToaster/reducer"
import successToastReducer from "../slices/toastMessage/reducer"
import DocumentToastReducer from "../slices/toastMessage/reducer"
import CustomerAllDataReducer from "../slices/reservations/customerlist/reducer"
import DocumentUploadReducer from "../slices/customer/documentupload/reducer"
import GetBillsForCustomerReducer from "../slices/customer/getbills/reducer"
import DocumentListReducer from "../slices/customer/documentlist/reducer"
import VerifyDocumentReducer from "../slices/customer/documentverify/reducer"
import UpdateDocumentReducer from "../slices/customer/documentupdate/reducer"
import DeleteDocumentReducer from "../slices/customer/documentdelete/reducer"
import ViewDocumentReducer from "../slices/customer/documentview/reducer"
import DownloadDocumentReducer from "../slices/customer/documentdownload/reducer"
import AllOrderReducer from "../slices/orderManagement/reducer"
import CreateOrderReducer from "../slices/orderManagement/CreateOrder/reducer"
import SelectOrderReducer from "../slices/orderManagement/selectedOrder/reducer"
import PartnerReducer from "../slices/PartnerMangement/reducer"
import CreatePartnerReducer from "../slices/PartnerMangement/CreatePartner/reducer"
import PolicyListReducer from "../slices/PartnerMangement/policylist/reducer"
import SelectDeviceReducer from "../slices/orderManagement/CreateOrder/SelectDevice/reducer"
import InvoiceStatisticsReducer from "../slices/invoices/invoicestatistics/reducer"
import InvoiceListReducer from "../slices/invoices/invoicelist/reducer"
import InvoiceListForCustomerReducer from "../slices/invoices/invoiceforcustomer/reducer"
import SelectedOfferForPartnerReducer from "../slices/PartnerMangement/OfferList/reducer"
import SelectedPartnerReducer from '../slices/PartnerMangement/PartnerList/reducer'
import DeviceSliceReducer from "../slices/Device/Devicelist/reducer"
import addDeviceSliceReducer from "../slices/Device/Adddevice/reducer"
import editDeviceSliceReducer from "../slices/Device/EditDevice/reducer"
import fetchDeviceSliceReducer from "../slices/Device/FetchDevice/reducer"
import cancelStatusSliceReducer from "../slices/Device/DeleteStatus/reducer"
import DocumentUpdateFileReducer from "../slices/customer/documentupdatefile/reducer"
import PartnerListReducer from "../slices/PartnerMangement/ListingPartner/reducer"
import EditPartnerReducer from "../slices/PartnerMangement/EditPartner/reducer"
import PartnerViewListReducer from "../slices/PartnerMangement/ViewListPartner/reducer"
import PartnerDocumentUploadReducer from "../slices/PartnerMangement/PartnerDocumentUpload/reducer"
import GetOrderByIdReducer from "../slices/orderManagement/getorder/reducer"
import SettlementPolicyReducer from "../slices/settlementPolicy/AddPolicy/reducer"
import GetSettlementPolicyReducer from "../slices/settlementPolicy/Getpolicy/reducer"
import deletePolicySliceReducer from "../slices/settlementPolicy/DeletePolicy/reducer"
import CustomerEventReducer from "../slices/customer/events/reducer"
import GetBillsForPartnerReducer from "../slices/PartnerMangement/GetPartnerBill/reducer"
import GetOfferReducer from "../slices/offer/getoffer/reducer"
import UpdateOfferReducer from "../slices/offer/updateoffer/reducer"
import GetPaymentForCustomerReducer from '../slices/payment/reducer'
import GetPopularPlanReducer from '../slices/PopularPlan/reducer'
import GetOrderByCustomerIdReducer from '../slices/orderManagement/GetOrderByCustomerId/reducer'
import GetStatisticDataForCustomerReducer from '../slices/customerDashboard/reducer'
import GetAllPoliciesReducer from '../slices/Policy/reducer'
import DeletePoliciesReducer from '../slices/Policy/DeletePolicy/reducer'
import CreatePoliciesReducer from '../slices/Policy/CreatePolicy/reducer'
import GetAllPoliciesByNameReducer from '../slices/Policy/GetPolicyByName/reducer'
import UpdatePoliciesReducer from '../slices/Policy/UpadatePolicy/reducer'
import CancelOrderReducer from '../slices/orderManagement/cancelorder/reducer'
import SearchedCustomerReducer from '../slices/customer/customerserach/reducer'
import GetMvnoDashboardReducer from '../slices/MvnoDashboard/reducer'
import GetAttributeByTypeReducer from "../slices/attribute/getattributebytype/reducer"
import GetAttributeByNameReducer from "../slices/attribute/getattributebyname/reducer"
import GetAllUserReducer from '../slices/UserManagement/reducer'
import CreateUserReducer from "../slices/UserManagement/CreateUser/reducer"
import GetAllUserByNameReducer from "../slices/UserManagement/GetUserByName/reducer"
import UpdateUserReducer from "../slices/UserManagement/UpdateUser/reducer"
import DeleteUserReducer from '../slices/UserManagement/DeleteUser/reducer'
import GetOperatorListReducer from '../slices/OperatorManagement/reducer'
import EditOperatorReducer from '../slices/OperatorManagement/EditOperator/reducer'
import CreateOperatorReducer from '../slices/OperatorManagement/CreateOperator/reducer'
import GetOperatorbyId from '../slices/OperatorManagement/GetOperatorbyID/reducer'
import SubscribeOrderReducer from '../slices/orderManagement/Subscribe/reducer'
import GetCustomerAI from '../slices/AI/reducer'
import ChangePlanReducer from './customer/changeplan/reducer'
import BalanceReducer from './customer/balance/reducer'
import GetAllTasksReducer from "./tasks/getalltasks/reducer"
import GetTaskByIdReducer from "./tasks/gettaskbyid/reducer"
import GetStatisticsOfTasksReducer from "./tasks/getstatistics/reducer"
import LogoViewReducer from '../slices/Logo/reducer'
import ResourceByIdReducer from '../slices/resources/getresourcebyID/reducer'
import CreateNewPasswordReducer from '../slices/UserManagement/PasswordManagement/reducer'
import SystemLogoViewReducer from "../slices/Logo/SystemUserViewLogo/reducer"
import DeleteCustomerByIdReducer from '../slices/customer/deletecustomer/reducer'
import EditResourceReducer from '../slices/resources/updateresource/reducer'
import DeleteUomReducer from '../slices/uom/deleteUom/reducer'
import GetUomByIdReducer from '../slices/uom/getUomByName/reducer'
import UpdateUomReducer from '../slices/uom/updateUom/reducer'
import ResetPasswordReducer from '../slices/ResetPassword/reducer'
import ExpiryCheckReducer from '../slices/ResetPassword/expiryCheck/reducer'
import ResetPasswordCreateReducer from '../slices/ResetPassword/ResetPasswordCreate/reducer'
import ViewReducer from '../slices/View/reducer'
import CreateViewReducer from '../slices/View/CreateView/reducer'
import SetPasswordCreateReducer from '../slices/SetPassword/reducer'
import EmailVerificationReducer from "../slices/EmailVerification/reducer"
import ProfileLogoReducer from "../slices/Logo/ProfileLogo/reducer"
import ForgotPassword from '../slices/ForgotPassword/reducer'
import ResendLinkReducer from '../slices/ResendLink/reducer'
import GetServiceReducer from '../slices/services/getservice/reducer'
import GetAllDefaultConfigurationReducer from '../slices/OperatorManagement/GetAllDefaultConfiguraions/reducer'
import GetAggregateResourceReducer from '../slices/resources/AggregateResource/reducer'
import DeleteViewReducer from '../slices/View/DeleteView/reducer'
import OperatorSpecificConfigReducer from "../slices/OperatorManagement/GetConfigurationByOperatorId/reducer"
import DetailedBalanceReducer from "../slices/customer/detailedBalance/reducer"
import GetAllSessionsReducer from "../slices/sessions/getAllSessions/reducer"
import EventTypeReducer from "../slices/sessions/eventType/reducer"
import GetOperatorSpecificConfigurationReducer from "../slices/OperatorManagement/GetConfigurationByOperatorId/reducer"
import GetConfigurationReducer from "../slices/OperatorManagement/GetConfiguration/reducer"
import GetAllCurrencyReducer from "../slices/OperatorManagement/GetCurrencyCodes/reducer"
import CreateEnquiryReducer from "../slices/EnquiryLandingPage/reducer"
import PreviewOrderReducer from "../slices/orderManagement/previewOrder/reducer"
import SetUpdatePasswordReducer from "../slices/customer/passwordUpdate/reducer"
import logoHeaderViewReducer from '../slices/Logo/HeaderLogo/reducer'
import rechargeReducer from '../slices/Recharge/reducer'
import GetAllQuotaReducer from '../slices/QuotaManagement/reducer'
import DeleteQuotaReducer from '../slices/QuotaManagement/DeleteQuota/reducer'
import AddQuotaReducer from '../slices/QuotaManagement/AddQuota/reducer'
import GetQuotaByEventReducer from '../slices/QuotaManagement/GetQuota/reducer'
import EditQuotaReducer from '../slices/QuotaManagement/UpdateQuota/reducer'
import GetAllRatingGroupReducer from '../slices/RatingGroup/reducer'
import DeleteRatingGroupReducer from '../slices/RatingGroup/DeleteRatingGroup/reducer'
import AddRatingGroupReducer from '../slices/RatingGroup/AddRatingGroup/reducer'
import GetRatingGroupByEventReducer from '../slices/RatingGroup/GetRatingGroup/reducer'
import EditRatingGroupReducer from '../slices/RatingGroup/UpdateRatingGroup/reducer'
import GetAllPeerConfigurationReducer from '../slices/PeerConfiguration/reducer'
import DeletePeerConfigurationReducer from '../slices/PeerConfiguration/DeletePeerConfiguration/reducer'
import AddPeerConfigurationReducer from '../slices/PeerConfiguration/AddPeerConfiguration/reducer'
import GetPeerConfigurationReducer from '../slices/PeerConfiguration/GetPeerConfiguration/reducer'
import EditPeerConfigurationReducer from '../slices/PeerConfiguration/UpdatePeerConfiguration/reducer'
import fetchCustomerCountReducer  from './customer/customerTagCount/reducer';
import TopConsumedCustomersReducer from './customer/customerConsumption/reducer';
import CreateStationReducer from '../slices/stations/createStation/reducer'
import fetchConsumedBalanceByCustomerReducer from '../slices/customer/ConsumedBalance/reducer'
import fetchOriginalBalanceByTagsReducer from '../slices/customer/OriginalBalanceByTags/reducer'
import AverageConsumedBalanceReducer from '../slices/customer/averageCost/reducer'
import getAllMidSessionReducer from '../slices/MidSession/reducer'
import AddMidSessionReducer from '../slices/MidSession/AddMidsession/reducer'
import deleteMidSessionReducer from '../slices/MidSession/DeleteMidSession/reducer'
import passwordWarningReducer from '../slices/passwordWarningSlice'
import GetAllUserRolesReducer from "../slices/UserRoleManagement/reducer"
import DeleteUserRoleReducer from "../slices/UserRoleManagement/DeleteRole/reducer"
import CreateUserRoleReducer from "../slices/UserRoleManagement/CreateRole/reducer"
import UpdateUserRoleReducer from "../slices/UserRoleManagement/EditRole/reducer"
import chargeRuleReducer from '../slices/ChargeRule/reducer';
import reservationAnalyticsReducer from '../slices/EVDashboard/ReservationAnalytics/reducer';
import reservationTrendsReducer from '../slices/EVDashboard/ReservationTrends/reducer';
import reservationSummaryReducer from '../slices/EVDashboard/ReservationSummary/reducer';
import stationUsageReducer from '../slices/EVDashboard/StationMetrics/reducer';
import usageStatistcsReducer from '../slices/customerDashboard/UsageStatistics/reducer';
import getPaymentHistoryReducer from '../slices/payment/PaymentHistory/reducer'
import StationUsageTrendsReducer from '../slices/EVDashboard/StationUsage/reducer'
import StationRevenueTrendsReducer from '../slices/EVDashboard/StationRevenue/reducer'
import StationUsageForecastReducer from '../slices/EVDashboard/StationUsageForecast/reducer'
import StationRevenueForecastReducer from '../slices/EVDashboard/StationRevenueForecast/reducer'
import CategoryReducer from '../slices/Category/GetCategory/reducer'
import GetSubCategoryReducer from '../slices/Category/GetSubCategory/reducer'
import CreateCategoryReducer from "../slices/Category/AddCategory/reducer"
import CreateSubCategoryReducer from "../slices/Category/AddSubCategory/reducer"
import EditCategoryReducer from "../slices/Category/EditCategory/reducer"
import EditSubCategoryReducer from "../slices/Category/EditSubCategory/reducer"
import DeleteCategoryReducer from "../slices/Category/DeleteCategory/reducer"
import DeleteSubCategoryReducer from "../slices/Category/DeleteSubCategory/reducer"
import LocationReducer from "../slices/Location/GetLocation/reducer"
import CreateLocationReducer from "../slices/Location/AddLocation/reducer"
import GetLocationTypeReducer from "../slices/Location/GetLocationType/reducer"
import UpdateLocationReducer from "../slices/Location/UpdateLocation/reducer"
import DeleteLocationReducer from "../slices/Location/DeleteLocation/reducer"
import CreateItemReducer from "../slices/Item/AddItem/reducer"
import GetItemsReducer from "../slices/Item/GetItem/reducer"
import GetItemSkuReducer from "../slices/Item/GetItemSKU/reducer"
import UpdateItemReducer from "../slices/Item/EditItem/reducer"
import DeleteItemReducer from "../slices/Item/DeleteItem/reducer"
import GetCatAttributeReducer from "../slices/Item/GetCatAttribute/reducer"
import GetCatBrandReducer from "../slices/Item/GetCatBrand/reducer"
import GetInventoryReducer from "../slices/Inventory/GetInventory/reducer"
import GetPriceBookReducer from "../slices/PriceBook/GetPriceBook/reducer"
import CreatePriceBookReducer from "../slices/PriceBook/AddPriceBook/reducer"
import UpdatePriceBookReducer from "../slices/PriceBook/UpdatePriceBook/reducer"
import DeletePriceBookReducer from "../slices/PriceBook/DeletePriceBook/reducer"
import GetPOReducer from "../slices/PO/GetPO/reducer"
import CreatePOReducer from "../slices/PO/CreatePO/reducer"
import UpdatePOReducer from "../slices/PO/UpdatePO/reducer"
import StockinRequestPOReducer from "./PO/ApprovalRequestPO/reducer"
import ApprovedRequestPOReducer from "./PO/ApprovedRequestPO/reducer"
import StockinCreationPOReducer from "../slices/PO/StockinCreate/reducer"
import GetSOReducer from "../slices/SO/GetSO/reducer"
import CreateSOReducer from "../slices/SO/CreateSO/reducer"
import UpdateSOReducer from "../slices/SO/UpdateSO/reducer"
import StocoutRequestSOReducer from "./SO/ApprovalRequestSO/reducer"
import ApprovedRequestSOReducer from "./SO/ApprovedRequestSO/reducer"
import StockoutCreationSOReducer from "../slices/SO/StockoutCreate/reducer"
// import NotificatiobSSEReducer from "../slices/Notification/GetNotification/reducer"
import GetNotificationReducer from "../slices/Notification/GetNotification/reducer"
import GetAllTransferReducer from "../slices/Transfer/GetallTransfer/reducer"
import CreateTransferReducer from "../slices/Transfer/CreateTransfer/reducer"
import CreateAdjustmentReducer from "../slices/Adjustment/CreateAdjustment/reducer"
import GetAllTransferInventoryReducer from "../slices/Transfer/GetallTransferInventory/reducer"
import UpdateNotificationReducer from "../slices/Notification/UpdateNotification/reducer"
import DeleteNotificationReducer from "../slices/Notification/DeleteNotification/reducer"

import CreatePartnerOfferReducer from "../slices/RedemptionOffer/CreateOffer/reducer"
import UploadPublicReducer from "../slices/RedemptionOffer/ImageUpload/reducer"
import GetAllOfferReducer from "../slices/RedemptionOffer/GetAllOffer/reducer"
import UpdatePartnerOfferReducer from "../slices/RedemptionOffer/UpdateOffer/reducer"
import DeletePartnerOfferReducer from "../slices/RedemptionOffer/DeleteOffer/reducer"
import GetAllOfferSearchReducer from "../slices/RedemptionOffer/GetAllOfferSearch/reducer"

import GetAllChargingSessionReducer from "../slices/EVChargingSessionReport/reducer"
import GetAllBPROneReducer from "../slices/EVBusinessPerformanceReport/GetAllBPROne/reducer"
import GetAllBPRTwoReducer from "../slices/EVBusinessPerformanceReport/GetAllBPRTwo/reducer"


const rootReducer = combineReducers({
    DefaultLogin: DefaultLoginReducer,
    SignIn: SignInReducer,
    Layout: LayoutReducer,
    Offer: OfferReducer,
    AddOffer: AddOfferReducer,
    Uom: UomReducer,
    AddUom: AddUomReducer,
    UsageEventType: UsageEventTypeReducer,
    AddUsageEventType: AddUsageEventTypeReducer,
    GetUomById:GetUomByIdReducer,
    DeleteUom : DeleteUomReducer,
    UpdateUom: UpdateUomReducer,
    CreateCustomer: CreateCustomerReducer,
    UpdateCustomer: UpdateCustomerReducer,
    FetchCustomer: FetchCustomerReducer,
    CustomerList: CustomerListReducer,
    Simulate: SimulateReducer,
    RateUsage: RateUsageReducer,
    CancelSubscription: CancelSubscriptionReducer,
    Services: ServiceReducer,
    Resources: ResourceReducer,
    Stations: StationReducer,
    Reservations: ReservationReducer,
    CreateService: CreateServiceReducer,
    CreateResource: CreateResourceReducer,
    Config: ConfigReducer,
    Provisional: ProvisionalReducer,
    permissions: permissionsReducer,
    EditStation: EditStationReducer,
    PostReservation: PostReservationReducer,
    UpdateReservation: UpdateReservationReducer,
    GetReservation: GetReservationReducer,
    DeleteResource: DeleteResourceReducer,
    Countries: CountriesReducer,
    States: StatesReducer,
    Cities: CitiesReducer,
    welcomeToast: welcomeToastReducer,
    SuccessToast: successToastReducer,
    CustomerAllData: CustomerAllDataReducer,
    Partner: PartnerReducer,
    CreatePartner: CreatePartnerReducer,
    EditPartner: EditPartnerReducer,
    DocumentUpload: DocumentUploadReducer,
    GetBillsForCustomer: GetBillsForCustomerReducer,
    DocumentList: DocumentListReducer,
    VerifyDocument: VerifyDocumentReducer,
    UpdateDocument: UpdateDocumentReducer,
    DeleteDocument: DeleteDocumentReducer,
    ViewDocument: ViewDocumentReducer,
    DownloadDocument: DownloadDocumentReducer,
    DocumentToast: DocumentToastReducer,
    OrderList: AllOrderReducer,
    CreateOrder: CreateOrderReducer,
    PolicyList: PolicyListReducer,
    SelectOrder: SelectOrderReducer,
    SelectedDevice: SelectDeviceReducer,
    AddDevice: addDeviceSliceReducer,
    updateDevice: editDeviceSliceReducer,
    fetchDevice: fetchDeviceSliceReducer,
    cancelStatus: cancelStatusSliceReducer,
    device: DeviceSliceReducer,
    InvoiceStatistics: InvoiceStatisticsReducer,
    InvoiceList: InvoiceListReducer,
    InvoiceListForCustomer: InvoiceListForCustomerReducer,
    SelectedOffer:SelectedOfferForPartnerReducer,
    SelectedPartner:SelectedPartnerReducer,
    PartnerList: PartnerListReducer,
    PartnerViewList: PartnerViewListReducer,
    DocumentUpdateFile: DocumentUpdateFileReducer,
    PartnerDocumentUpload: PartnerDocumentUploadReducer,
    GetOrderById: GetOrderByIdReducer,
    SettlementPolicy: SettlementPolicyReducer,
    GetSettlementPolicy:GetSettlementPolicyReducer,
    deletePolicy :deletePolicySliceReducer,
    CustomerEvent : CustomerEventReducer,
    GetBillsForPartner:GetBillsForPartnerReducer,
    GetOffer: GetOfferReducer,
    UpdateOffer: UpdateOfferReducer,
    GetPaymentForCustomer:GetPaymentForCustomerReducer,
    GetPopularPlan:GetPopularPlanReducer,
    GetOrderByCustomerId:GetOrderByCustomerIdReducer,
    GetStatisticDataForCustomer:GetStatisticDataForCustomerReducer,
    GetAllPolicies:GetAllPoliciesReducer,
    DeletePolicies:DeletePoliciesReducer,
    CreatePolicies:CreatePoliciesReducer,
    GetAllPoliciesByName:GetAllPoliciesByNameReducer,
    UpdatePolicies:UpdatePoliciesReducer,
    CancelOrder: CancelOrderReducer,
    SearchedCustomer: SearchedCustomerReducer,
    GetMvnoDashboard:GetMvnoDashboardReducer,
    GetAttributeByType: GetAttributeByTypeReducer,
    GetAttributeByName : GetAttributeByNameReducer,
    GetAllUser:GetAllUserReducer,
    CreateUser:CreateUserReducer,
    GetAllUserByName:GetAllUserByNameReducer,
    UpdateUser:UpdateUserReducer,
    DeleteUser:DeleteUserReducer,
    GetMvnoDashboard:GetMvnoDashboardReducer,
    GetOperatorList:GetOperatorListReducer,
    EditOperator:EditOperatorReducer,
    CreateOperator:CreateOperatorReducer,
    GetOperator:GetOperatorbyId,
    SubscribeOrder:SubscribeOrderReducer,
    GetCustomerAIbyId:GetCustomerAI,
    CreateNewPassword:CreateNewPasswordReducer,
    ChangePlan: ChangePlanReducer,
    Balance:BalanceReducer,
    GetAllTasks:GetAllTasksReducer,
    GetTaskById:GetTaskByIdReducer,
    GetStatisticsOfTasks:GetStatisticsOfTasksReducer,
    LogoView:LogoViewReducer,
    ResourceById:ResourceByIdReducer,
    DeleteCustomerById: DeleteCustomerByIdReducer,
    EditResource:EditResourceReducer,
    ResetPassword:ResetPasswordReducer,
    ExpiryCheck:ExpiryCheckReducer,
    SystemLogoView:SystemLogoViewReducer,
    ResetPasswordCreate:ResetPasswordCreateReducer,
    View:ViewReducer,
    CreateView:CreateViewReducer,
    SetPasswordCreate:SetPasswordCreateReducer,
    EmailVerification:EmailVerificationReducer,
    ProfileLogo:ProfileLogoReducer,
    ForgotPassword:ForgotPassword,
    ResendLink:ResendLinkReducer,
    GetService :GetServiceReducer,
    GetAllDefaultConfiguration :GetAllDefaultConfigurationReducer,
    GetAggregateResource :GetAggregateResourceReducer,
    DeleteView: DeleteViewReducer,
    OperatorSpecificConfig:OperatorSpecificConfigReducer,
    DetailedBalance: DetailedBalanceReducer,
    GetAllSessions:GetAllSessionsReducer,
    EventType:EventTypeReducer,
    GetOperatorSpecificConfiguration:GetOperatorSpecificConfigurationReducer,
    CreateEnquiry : CreateEnquiryReducer,
    previewOrder : PreviewOrderReducer,
    SetUpdatePassword: SetUpdatePasswordReducer,
    logoHeaderView:logoHeaderViewReducer,
    Recharge:rechargeReducer,
    GetAllCurrency:GetAllCurrencyReducer,
    GetAllQuota:GetAllQuotaReducer,
    DeleteQuota:DeleteQuotaReducer,
    AddQuota:AddQuotaReducer,
    GetQuotaByEvent:GetQuotaByEventReducer,
    EditQuota:EditQuotaReducer,
    GetAllRatingGroup:GetAllRatingGroupReducer,
    DeleteRatingGroup:DeleteRatingGroupReducer,
    AddRatingGroup:AddRatingGroupReducer,
    GetRatingGroupByEvent:GetRatingGroupByEventReducer,
    EditRatingGroup:EditRatingGroupReducer,
    GetAllPeerConfiguration:GetAllPeerConfigurationReducer,
    DeletePeerConfiguration:DeletePeerConfigurationReducer,
    AddPeerConfiguration:AddPeerConfigurationReducer,
    GetPeerConfiguration:GetPeerConfigurationReducer,
    EditPeerConfiguration:EditPeerConfigurationReducer,
    fetchCustomerCount:fetchCustomerCountReducer,
    TopConsumedCustomers: TopConsumedCustomersReducer,
    CreateStation:CreateStationReducer,
    fetchConsumedBalanceByCustomer: fetchConsumedBalanceByCustomerReducer,
    fetchOriginalBalanceByTags: fetchOriginalBalanceByTagsReducer,
    AverageConsumedBalance: AverageConsumedBalanceReducer,
    getAllMidSession:getAllMidSessionReducer,
    AddMidSession: AddMidSessionReducer,
    deleteMidSession:deleteMidSessionReducer,
    passwordWarning: passwordWarningReducer,
    GetAllUserRoles:GetAllUserRolesReducer,
    DeleteUserRole:DeleteUserRoleReducer,
    CreateUserRole:CreateUserRoleReducer,
    UpdateUserRole:UpdateUserRoleReducer,
    GetConfiguration:GetConfigurationReducer,
    ChargeRule: chargeRuleReducer,
    ReservationAnalytics: reservationAnalyticsReducer,
    ReservationTrends: reservationTrendsReducer,
    ReservationSummary: reservationSummaryReducer,
    StationUsage: stationUsageReducer,
    UsageStatistcs: usageStatistcsReducer,
    getPaymentHistory:getPaymentHistoryReducer,
    StationUsageTrends:StationUsageTrendsReducer,
    StationRevenueTrends:StationRevenueTrendsReducer,
    StationUsageForecast:StationUsageForecastReducer,
    StationRevenueForecast:StationRevenueForecastReducer,
    Category:CategoryReducer,
    GetSubCategory:GetSubCategoryReducer,
    CreateCategory:CreateCategoryReducer,
    CreateSubCategory:CreateSubCategoryReducer,
    EditCategory: EditCategoryReducer,
    EditSubCategory: EditSubCategoryReducer,
    DeleteCategory: DeleteCategoryReducer,
    DeleteSubCategory: DeleteSubCategoryReducer,
    locations: LocationReducer,
    CreateLocation:CreateLocationReducer,
    GetLocationType:GetLocationTypeReducer,
    UpdateLocation:UpdateLocationReducer,
    DeleteLocation: DeleteLocationReducer,
    CreateItem:CreateItemReducer,
    GetItems:GetItemsReducer,
    GetItemSku:GetItemSkuReducer,
    UpdateItem:UpdateItemReducer,
    DeleteItem: DeleteItemReducer,
    GetCatAttribute: GetCatAttributeReducer,
    GetCatBrand: GetCatBrandReducer,
    GetInventory: GetInventoryReducer,
    GetPriceBook: GetPriceBookReducer,
    CreatePriceBook: CreatePriceBookReducer,
    UpdatePriceBook: UpdatePriceBookReducer,
    DeletePriceBook: DeletePriceBookReducer,
    GetPO:GetPOReducer,
    CreatePO: CreatePOReducer,
    UpdatePO: UpdatePOReducer,
    StockinRequestPO: StockinRequestPOReducer,
    ApprovedRequestPO: ApprovedRequestPOReducer,
    StockinCreationPO: StockinCreationPOReducer,
    GetSO:GetSOReducer,
    CreateSO: CreateSOReducer,
    UpdateSO: UpdateSOReducer,
    StockoutRequestSO: StocoutRequestSOReducer,
    ApprovedRequestSO: ApprovedRequestSOReducer,
    StockoutCreationSO: StockoutCreationSOReducer,
    // NotificationSSE: NotificationSSEReducer,
    GetAllTransfer: GetAllTransferReducer,
    CreateTransfer: CreateTransferReducer,
    CreateAdjustment: CreateAdjustmentReducer,
    GetAllTransferInventory: GetAllTransferInventoryReducer,
    GetNotification: GetNotificationReducer,
    UpdateNotification: UpdateNotificationReducer,
    DeleteNotification: DeleteNotificationReducer,

    CreatePartnerOffer: CreatePartnerOfferReducer,
    UploadPublic: UploadPublicReducer,
    GetAllOffer: GetAllOfferReducer,
    UpdatePartnerOffer: UpdatePartnerOfferReducer,
    DeletePartnerOffer: DeletePartnerOfferReducer,
    GetAllOfferSearch:GetAllOfferSearchReducer,
    GetAllChargingSession:GetAllChargingSessionReducer,
    GetAllBPROne:GetAllBPROneReducer,
    GetAllBPRTwo:GetAllBPRTwoReducer
});

export default rootReducer;